import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

export const scrollToEl = (el, offset = 0) => {
    if (!el) return

    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
    const elOffsetTop = el.getBoundingClientRect().top + document.documentElement.scrollTop

    window.scroll({
        top: elOffsetTop - headerHeight - offset,
        behavior: 'smooth'
    })
}

export const initAnchors = () => {
    document.querySelectorAll('[r-anchor]').forEach((anchor) => {
        if (anchor.classList.contains('r-anchor-initialized')) return

        anchor.addEventListener('click', (event) => {
            event.preventDefault()
            const offset = parseInt(event.currentTarget.dataset.anchorOffset) || 40
            window.isAnchorScrolling = true
            scrollToEl(document.getElementById(event.currentTarget.getAttribute('r-anchor')), offset)
            setTimeout(() => {
                window.isAnchorScrolling = false
            }, 1000)
        })

        anchor.classList.add('r-anchor-initialized')
    })
}
